export default __webpack_public_path__ + "static/media/1678.d52adc76.png";